// 서비스 이용약관 페이지
import React from "react";
import { Link } from "react-router-dom";

const Section: React.FC<{ title: string; children: React.ReactNode }> = ({ title, children }) => (
  <section className="mb-8">
    <h2 className="mb-3 text-base font-bold text-slate-800">{title}</h2>
    <div className="space-y-2 text-sm leading-relaxed text-slate-600">{children}</div>
  </section>
);

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-slate-50">
      {/* 헤더 */}
      <div className="border-b border-slate-200 bg-white">
        <div className="mx-auto max-w-3xl px-4 py-6">
          <Link to="/" className="mb-4 inline-flex items-center gap-1.5 text-sm text-slate-500 hover:text-slate-700">
            ← 홈으로
          </Link>
          <h1 className="text-2xl font-extrabold text-slate-900">서비스 이용약관</h1>
          <p className="mt-1 text-sm text-slate-500">시행일: 2025년 6월 1일</p>
        </div>
      </div>

      <div className="mx-auto max-w-3xl px-4 py-10">
        <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm md:p-10">

          <Section title="제1조 목적">
            <p>이 약관은 새로운 연구소(이하 "회사")가 제공하는 학원 관리 서비스(이하 "서비스")의
              이용 조건 및 절차, 회사와 이용자 간의 권리·의무 및 책임 사항을 규정함을 목적으로 합니다.</p>
          </Section>

          <Section title="제2조 용어의 정의">
            <ul className="ml-4 list-disc space-y-1">
              <li>"서비스"란 회사가 제공하는 학원 관리 플랫폼(학생 관리, 출석 관리, 학습 보고서, 수업료 결제 등)을 의미합니다.</li>
              <li>"이용자"란 이 약관에 따라 회사가 제공하는 서비스를 받는 교사·학생·학부모 회원을 의미합니다.</li>
              <li>"교사 계정"이란 학원 운영 목적으로 가입한 이용자의 계정을 의미합니다.</li>
            </ul>
          </Section>

          <Section title="제3조 약관의 효력과 변경">
            <ul className="ml-4 list-disc space-y-1">
              <li>이 약관은 서비스를 이용하고자 하는 모든 이용자에게 적용됩니다.</li>
              <li>회사는 합리적인 사유가 발생할 경우 관련 법령에 위배되지 않는 범위 내에서 약관을 변경할 수 있습니다.</li>
              <li>약관이 변경되는 경우 회사는 변경 내용과 시행일을 서비스 내 공지합니다. 시행일 이후 서비스를 계속 이용하면 변경된 약관에 동의한 것으로 간주합니다.</li>
            </ul>
          </Section>

          <Section title="제4조 서비스 이용 계약">
            <ul className="ml-4 list-disc space-y-1">
              <li>이용 계약은 이용자가 회원가입 시 이 약관에 동의하고 회사가 이를 승낙함으로써 성립합니다.</li>
              <li>만 14세 미만의 아동은 회원으로 가입할 수 없습니다.</li>
              <li>회사는 다음 각 호에 해당하는 경우 가입을 거절하거나 사후 계약을 해지할 수 있습니다.
                <ul className="ml-4 mt-1 list-disc space-y-1">
                  <li>타인의 정보를 도용한 경우</li>
                  <li>허위 정보를 기재한 경우</li>
                  <li>서비스의 정상적인 운영을 방해한 경우</li>
                </ul>
              </li>
            </ul>
          </Section>

          <Section title="제5조 서비스 제공 및 변경">
            <ul className="ml-4 list-disc space-y-1">
              <li>회사는 연중무휴 24시간 서비스 제공을 원칙으로 합니다. 다만, 정기 점검·시스템 장애 등의 사유로 일시 중단될 수 있습니다.</li>
              <li>회사는 서비스의 내용을 변경할 수 있으며, 이 경우 서비스 내 공지합니다.</li>
              <li>회사는 서비스 운영상·기술상 필요한 경우 서비스를 종료할 수 있으며, 30일 전 공지합니다.</li>
            </ul>
          </Section>

          <Section title="제6조 이용자의 의무">
            <p>이용자는 다음 각 호의 행위를 해서는 안 됩니다.</p>
            <ul className="ml-4 mt-2 list-disc space-y-1">
              <li>타인의 개인정보를 도용하거나 허위 정보를 등록하는 행위</li>
              <li>서비스를 통해 취득한 정보를 회사의 사전 동의 없이 복제·배포·상업적으로 이용하는 행위</li>
              <li>서비스의 정상적인 운영을 방해하는 행위 (해킹, 크롤링, 무단 자동화 등)</li>
              <li>다른 이용자의 개인정보를 수집·저장·공개하는 행위</li>
              <li>관련 법령을 위반하는 행위</li>
            </ul>
          </Section>

          <Section title="제7조 서비스 이용 요금">
            <ul className="ml-4 list-disc space-y-1">
              <li>서비스의 기본 이용 요금 정책은 서비스 내 별도 안내 페이지에 명시합니다.</li>
              <li>유료 서비스 이용 요금은 사전에 공지된 요금에 따라 부과됩니다.</li>
              <li>요금 환불은 관련 법령 및 별도 환불 정책에 따릅니다.</li>
            </ul>
          </Section>

          <Section title="제8조 개인정보 보호">
            <p>회사는 관련 법령이 정하는 바에 따라 이용자의 개인정보를 보호합니다.
              개인정보의 수집·이용·제공 등에 관한 자세한 사항은
              <Link to="/privacy" className="mx-1 text-teal-600 underline">개인정보처리방침</Link>
              에서 확인하실 수 있습니다.</p>
          </Section>

          <Section title="제9조 책임의 제한">
            <ul className="ml-4 list-disc space-y-1">
              <li>회사는 천재지변, 불가항력적 사유로 서비스를 제공하지 못하는 경우 책임이 면제됩니다.</li>
              <li>회사는 이용자의 귀책 사유로 발생한 서비스 이용 장애에 대해 책임을 지지 않습니다.</li>
              <li>회사는 이용자가 서비스를 통해 얻은 정보·자료 등의 신뢰도·정확성에 대해 보증하지 않습니다.</li>
              <li>AI 분석 결과는 참고 자료로만 활용해야 하며, 회사는 AI 결과의 정확성을 보장하지 않습니다.</li>
            </ul>
          </Section>

          <Section title="제10조 분쟁 해결 및 관할 법원">
            <ul className="ml-4 list-disc space-y-1">
              <li>서비스 이용과 관련하여 발생한 분쟁에 대해 회사와 이용자는 상호 합의하여 원만히 해결하도록 노력합니다.</li>
              <li>협의가 이루어지지 않을 경우 회사의 소재지를 관할하는 법원을 관할 법원으로 합니다.</li>
              <li>이 약관은 대한민국 법령에 따라 해석됩니다.</li>
            </ul>
          </Section>

          <div className="mt-8 rounded-xl border border-slate-100 bg-slate-50 p-4 text-xs text-slate-500">
            이 약관은 2025년 6월 1일부터 시행됩니다.
          </div>

        </div>
      </div>
    </div>
  );
}
